import { useCallback, useState } from "react";
// import { useQuery } from "@tanstack/react-query";
import axios from "axios";

// export function useAzureSas(org?: string) {
//   const getData = useCallback(async () => {
//     const res = await axios.get<{
//       service: string;
//       container: string;
//       sas: string;
//       expiryUtc: string;
//     }>(`/${org}/imagery/orthouploader/sas`);
//     return res.data;
//   }, [org]);

//   return useQuery({
//     queryKey: ["azure-sas", org],
//     queryFn: getData,
//     enabled: Boolean(org),
//   });
// }

export function useAzureSas(org?: string) {
  const [sasData, setSasData] = useState<{
    container: string;
    service: string;
    sas: string;
  } | null>(null);

  const fetchSas = useCallback(async () => {
    const res = await axios.get<{
      service: string;
      container: string;
      sas: string;
      expiryUtc: string;
    }>(`/${org}/imagery/orthouploader/sas`);
    if (!res.data) throw new Error("Failed to fetch SAS token");
    // const json = await res.json();
    setSasData(res.data);
    return res.data;
  }, [org]);

  return {
    sasData,
    fetchSas,
  };
}
